<template>
  <div :key="`${category}-${loggedIn}`" class="relative min-h-[500px]">
    <div v-if="loading" class="absolute left-0 w-full lg:top-1/2">
      <TheLoader />
    </div>

    <div v-if="!loading">
      <AssessmentsReportList
        :reports="reports"
        :category="category"
        :market-slug="product"
        :initial-fields="initialFields"
        :show-latest-report-section="showLatestReportSection"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TMarketType, TMarketSlug } from '~/src/types/markets'
import type { TReport } from '~/src/types/reports'
import { MARKET_TYPE } from '~/src/constants/markets'
import TheLoader from '~/components/TheLoader.vue'
import AssessmentsReportList from '~/components/assessments/ReportList.vue'
import { useAuthentication } from '~/composables/useAuthentication'
import { useReports } from '~/composables/useReports'

import { logError } from '~/utils/log-error'
import type { TRecord } from '~/src/types/common'

const props = withDefaults(
  defineProps<{
    category: TMarketType
    product: TMarketSlug
    initialFields?: TRecord[]
    marketType?: TMarketType
    showLatestReportSection?: boolean
  }>(),
  {
    marketType: MARKET_TYPE.PRICES_ASSESSMENTS,
    showLatestReportSection: false,
  },
)

const { loggedIn } = useAuthentication()
const { getReportAndModelData } = useReports()

const reports = ref<TReport[]>([])
const loading = ref(true)

async function getReports() {
  loading.value = true
  try {
    const marketSlug = props.product
    reports.value = await getReportAndModelData(
      marketSlug,
      [props.marketType],
      true,
      -1,
    )
  } catch (error) {
    logError(error)
  } finally {
    loading.value = false
  }
}

useAuthentication(getReports)

onMounted(() => {
  getReports()
})
</script>
